<template>
  <div id="input-packing-info-modal" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false" @click.stop>
    <div class="modal-dialog modal-custom" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">梱包情報入力</h5>
          <div class="text--underline">
            <b class="text-size-20">輸送箱ごと</b> に <b class="text-size-20">どの商品</b> を <b class="text-size-20">何個</b> 入れるかを登録してください。
          </div>
        </div>
        <div class="modal-body">
          <div class="flexbox justify-right mr-b-10">
            <button class="btn btn-primary" :disabled="boxCount >= maxBox" @click="addBoxes" type="button">
              <i class="fa fa-plus-circle"></i>
              箱追加
            </button>
          </div>
          <table id="input-packing-info-table">
            <thead>
              <tr>
                <th class="fixed-column" style="min-width: 620px;">商品</th>
                <th class="fixed-column-2">納品予定数</th>
                <th v-for="i in boxCount" :key="i">輸送箱{{ i }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in products" :key="product.asin">
                <!-- PRODUCT INFO -->
                <td class="fixed-column product-info">
                  <div class="product-wrapper">
                    <img :src="product.image" class="product-img" />
                    <div class="product-text">
                      <div class="name">{{ product.itemName }}</div>
                      <div class="meta">
                        ASIN：{{ product.asin }} / SKU：{{ product.sku }} / FNSKU：{{ product.fnsku }}
                      </div>
                      <div class="meta">
                        商品ラベル：{{ product.fnsku }}
                      </div>
                    </div>
                  </div>
                </td>
                <!-- QUANTITY -->
                <td class="fixed-column-2 text-center">
                  {{ totalQuantity(product.asin) }} / {{ product.quantity }}
                </td>
                <!-- BOX INPUT -->
                <td v-for="i in boxCount" :key="i">
                  <input
                    type="text"
                    class="form-control"
                    v-model.number="boxes[i - 1][product.asin]"
                    @input="onInput(i, product)"
                  />
                </td>

              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" :disabled="isDisabledSubmit" @click="handleSubmit">梱包情報を確定させ納品登録を行う</button>
          <button type="button" class="btn btn-secondary" @click="$emit('close')">閉じる</button>
        </div>
      </div>
    </div>
    <modal-confirm
      v-if="openConfirmModal"
      :message="confirmMessage"
      @confirm="handleRegister"
      @close="closeModalConfirm"
    />
  </div>
</template>

<script>
import ModalConfirm from '@/components/ModalConfirm'

export default {
  components: {
    ModalConfirm
  },
  props: {
    products: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      boxCount: 5,
      maxBox: 50,
      boxes: [],
      openConfirmModal: false,
      confirmMessage: '納品情報を登録します。よろしいですか？'
    }
  },
  created () {
    this.initializeBoxes()
  },
  mounted () {
    $('#input-packing-info-modal').modal('show')
  },
  computed: {
    isDisabledSubmit () {
      return this.products.some(product => {
        const total = this.totalQuantity(product.asin)

        return (
          total <= 0 ||
          total !== Number(product.quantity)
        )
      })
    }
  },
  methods: {
    initializeBoxes () {
      for (let i = 0; i < this.boxCount; i++) {
        const box = {}

        this.products.forEach(product => {
          box[product.asin] = null
        })

        this.boxes.push(box)
      }
    },
    addBoxes () {
      if (this.boxCount >= this.maxBox) return

      const next = Math.min(this.boxCount + 5, this.maxBox)

      for (let i = this.boxCount; i < next; i++) {
        const box = {}

        this.products.forEach(product => {
          box[product.asin] = null
        })

        this.boxes.push(box)
      }

      this.boxCount = next
    },
    onInput (boxIndex, product) {
      const value = this.boxes[boxIndex - 1][product.asin]

      if (value < 0 || isNaN(value)) {
        this.$set(this.boxes[boxIndex - 1], product.asin, 0)
      }
    },
    totalQuantity (asin) {
      return this.boxes.reduce((sum, box) => {
        return sum + Number(box[asin] || 0)
      }, 0)
    },
    handleSubmit () {
      if (this.isDisabledSubmit) {
        return
      }

      this.openModalConfirm()
    },
    openModalConfirm () {
      this.openConfirmModal = true
    },
    closeModalConfirm () {
      $('#confirm-alert').modal('hide')
      this.openConfirmModal = false
    },
    handleRegister () {
      this.closeModalConfirm()
      this.$emit('handleRegister', this.boxes)
    }
  },
  beforeDestroy () {
    $('#input-packing-info-modal').modal('hide')
  }
}
</script>

<style scoped>
#input-packing-info-modal {
  .modal-custom {
    width: 90%;
    max-width: 1400px;
    .modal-footer {
      border-radius: 0 0 5px 5px;
    }
    .modal-header {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
  }
  #input-packing-info-table {
    display: block;
    margin: 0 auto;
    overflow-x: auto;
    max-height: 60vh;
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
  }
  #input-packing-info-table th,
  #input-packing-info-table td {
    border: 1px solid #dcdcdc;
    padding: 6px;
    min-width: 120px;
    background: #fff;
  }
  #input-packing-info-table thead th {
    position: sticky;
    top: 0;
    background: #deebf7;
    text-align: center;
  }

  .product-info {
    min-width: 500px;
    width: 500px;
  }

  .fixed-column {
    position: sticky;
    left: 0;
    z-index: 2;
    background: #fff;
  }

  .fixed-column-2 {
    position: sticky;
    left: 620px;
    z-index: 2;
    background: #fff;
  }

  .product-wrapper {
    display: flex;
    gap: 10px;
  }

  .product-img {
    width: 40px;
    height: 40px;
  }

  .product-text {
    font-size: 12px;
    line-height: 1.4;
  }

  .product-text .name {
    font-weight: bold;
  }

  .product-text .meta {
    color: #666;
  }

  .form-control {
    width: 70px;
    height: 28px;
    text-align: center;
    font-size: 13px;
    margin: 0 auto;
  }

  tbody tr {
    background: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/components/InputPackingInfoModal.vue